import { DateTime } from 'luxon';
import T from 'localization/LocalizationKeys';


const cullDateOnRecentTimestamp = (timestamp) => {
  if (DateTime.now().day !== timestamp.day) {
    return timestamp.toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS);
  }
  return timestamp.toLocaleString(DateTime.TIME_WITH_SECONDS);

};


export const formatTimestamp = (isoTimestamp) => {
  if (!isoTimestamp.isValid) {
    return '';
  }
  return cullDateOnRecentTimestamp(isoTimestamp);
};

export const timeToString = (time) => DateTime.fromMillis(time).toFormat('yyyy-MM-dd HH:mm:ss');

export const isoToRelative = (isoTimestamp) => {
  const now = DateTime.now();
  const ts = DateTime.fromISO(isoTimestamp);
  if (!ts.isValid) {
    return '';
  }
  if (ts < DateTime.now().minus({ years: 100 })) {
    return T.localize(T.common.never);
  }
  if (ts > now) {
    return now.toRelative();
  }
  return ts.toRelative();
};

// show relative time for less than 1 day, otherwise show absolute time
export const isoToRelativeOrAbsolute = (isoTimestamp) => {

  const ts = DateTime.fromISO(isoTimestamp);
  if (!ts.isValid) {
    return '';
  }
  if (ts > DateTime.now().minus({ days: 1 })) {
    return isoToRelative(isoTimestamp);
  }
  return ts.toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS);
};
